import React from "react";
import techImage from "../Images/LaTech.jpg"; // Replace with your actual image path or import
import "../Styles/LatestTechnology.css";
const LatestTechnology = () => {
  return (
    <section className="latest-tech-section">
      <h2 className="section-title">
        Latest <span>Technology</span>
      </h2>
      <p className="section-subtitle">
        Thanks to major technological advancements, dentistry allows treating
        the most complex cases with less time and more efficiency.
      </p>

      <div className="content-wrapper">
        <div className="image-container">
          <img src={techImage} alt="Dental Technology" />
        </div>

        <div className="text-container">
          <h3>The Future Of Dentistry Is Digital:</h3>
          <p>
            Dentists today already utilize software to capture insights in
            clinical decision-making. These practices will continue to develop
            to integrate AI algorithms that enable clinicians to find the best
            modalities for their patients.
          </p>
          <p>
            In the 21st century, digital radiographs and 3D imaging have become
            the standard of dental care. Using an intraoral scanner with
            digitized data for 3D dental impressions (vs. polyvinyl siloxane and
            rubber base impressions) for a dental crown is now commonplace.
          </p>
          <p>
            Artificial intelligence is laying the groundwork for the future of
            the dental industry. Dental robots can now perform functions such as
            filling cavities and cleaning or extracting teeth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LatestTechnology;
